
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/help/delivery",
      function () {
        return require("private-next-pages/help/delivery.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/help/delivery"])
      });
    }
  